import { SecondaryButton, Spinner } from "ui";
import useGetQueueConfig from "../apis/tryst/get-queue-config";
import { useEffect, useState } from "react";
import {
  AppointmentConfigs,
  appointmentConfigTitleMapping,
} from "@elixir/types";
import usePostAppointmentConfig from "../apis/tryst/use-post-appointment-config";
import { notification, Switch } from "antd";
import SlotOverbookingLimitComponent from "./slot-overbooking-limit";

const AppointmentConfigsScreen = () => {
  const { data: queueConfigData, isLoading } = useGetQueueConfig();

  const { mutateAsync: postAppointmentConfig, isLoading: isSetConfigLoading } =
    usePostAppointmentConfig();

  const [currentConfigValues, setCurrentConfigValues] = useState<
    AppointmentConfigs["apt_config"] | undefined
  >();

  useEffect(() => {
    if (!isLoading && queueConfigData) {
      setCurrentConfigValues(queueConfigData.data?.apt_config);
    }
  }, [queueConfigData, isLoading]);

  const [isConfigChanged, setIsConfigChanged] = useState<boolean>(false);

  const onSave = async () => {
    const { success } = await postAppointmentConfig({
      preferenceFor: "apt_config",
      preferences: currentConfigValues,
    });
    if (success) {
      notification.success({
        message: "Config Set Successfully!",
      });
      setIsConfigChanged(false);
    } else {
      notification.error({
        message: "Error occured while setting config!!",
      });
    }
  };

  return (
    <div className="dr-w-full dr-relative dr-h-full">
      <div className="HeadlineBold dr-py-16 dr-px-24">Queue Configuration</div>
      <div className="dr-max-w-600">
        {isLoading ? (
          <Spinner size={15} className={"dr-text-darwin-primary-primary"} />
        ) : (
          (
            Object.keys(appointmentConfigTitleMapping) as Array<
              keyof AppointmentConfigs["apt_config"]
            >
          ).map((key) => {
            return (
              <div className="dr-flex dr-flex-row dr-items-center dr-justify-between dr-py-11 dr-px-24">
                <div className="dr-h-32 dr-flex dr-flex-row dr-items-center dr-space-x-8">
                  <div className="SubheadlineBold">
                    {appointmentConfigTitleMapping[key]}
                  </div>
                  {key === "allow_slot_overbooking" &&
                    currentConfigValues?.[key] && (
                      <SlotOverbookingLimitComponent
                        currentConfigValues={currentConfigValues}
                        setIsConfigChanged={setIsConfigChanged}
                        setCurrentConfigValues={setCurrentConfigValues}
                        onSave={onSave}
                        isDisabled={!isConfigChanged}
                        isLoading={isSetConfigLoading}
                      />
                    )}
                </div>
                <Switch
                  onChange={async () => {
                    setIsConfigChanged(true);
                    setCurrentConfigValues((prev: any) => {
                      if (!prev) {
                        return {
                          [key]: true,
                        } as Record<
                          keyof AppointmentConfigs["apt_config"],
                          boolean
                        >;
                      }
                      return {
                        ...prev,
                        [key]: !prev[key],
                      };
                    });
                  }}
                  checked={currentConfigValues?.[key] as boolean}
                  size="default"
                />
              </div>
            );
          })
        )}
      </div>
      <div
        className="dr-absolute dr-left-16 dr-bottom-24 dr-right-16 dr-h-52 dr-rounded-8 dr-flex dr-justify-end dr-py-8 dr-px-16"
        style={{ backgroundColor: "#004BA8" }}
      >
        <SecondaryButton
          onClick={onSave}
          title="Save changes"
          textColor="dr-text-background-action-primary-hover"
          isDisabled={!isConfigChanged}
          isLoading={isSetConfigLoading}
        />
      </div>
    </div>
  );
};

export default AppointmentConfigsScreen;
